// Import utils
import { isEmpty } from '@automator/shared/utils/is-empty';

/**
 * Checks if an integration has loop filters
 *
 * @param {Object} integration An integration.
 * @param {String} [loopFilterType] The type of loop filter to check for. Either empty (all), "users" or "posts".
 * @return {Boolean} Whether the integration is available.
 */
const integrationHasLoopFilters = ( integration, loopFilterType = 'users' ) => {
	// If it doesn't have any type of loop filters at all, stop here
	if ( isEmpty( integration.loop_filters ) ) {
		return false;
	}

	// If we don't have to filter by loop filter type, stop here, we have loop filters
	if ( isEmpty( loopFilterType ) ) {
		return true;
	}

	// If we have to filter by loop filter type, check if the integration has loop filters of that type
	return Object.values( integration.loop_filters ).some( loopFilter => loopFilter.loop_type === loopFilterType );
}

export default integrationHasLoopFilters;
